import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, computed } from "vue";
import request from "@/plugin/request";
type TaskDetail = {
  compareNum: number;
  compareImgs: string;
  searchImgs: string;
  searchTagList: number;
  searchTagsImgs: string;
  needAddCart: number;
  addCartImgs: string;
  needAddComment: number;
  addCommentPrompt: string;
  addCommentImgs: string;
  needAnswer: number;
  answerPrompt: string;
  answerImgs: string;
  needBrowseComments: number;
  browseCommentsImgs: string;
  needChat: number;
  chatImgs: string;
  needCollect: number;
  collectImgs: string;
  needComment: number;
  commentImgs: string;
  needCommercialInsurance: number;
  commercialInsuranceImgs: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'TrialSnapshot',
  props: {
    value: { type: Boolean },
    id: null
  },
  emits: ["input"],
  setup(__props: any, { emit }) {

const props = __props as {
  value: boolean;
  id: string;
};

const taskDetail = (id: string) => request.get("/task/get?id=" + id);


const show = computed({
  get() {
    return props.value;
  },
  set(val) {
    emit("input", val);
  },
});
const loading = ref(false);
const detail = ref<TaskDetail>();
const checkList = computed(() => {
  if (detail.value == undefined) return [];
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const data = detail.value!;
  const list = [];
  if (data.compareNum > 0) {
    list.push({
      name: "比货",
      imgs: data.compareImgs?.split(",") ?? [],
    });
  }
  list.push({
    name: "搜索",
    imgs: data.searchImgs?.split(",") ?? [],
  });
  if (data.searchTagList > 0) {
    list.push({
      name: "搜索魔法标签",
      imgs: data.searchTagsImgs?.split(",") ?? [],
    });
  }

  // 浏览评价
  if (data.needBrowseComments > 0) {
    list.push({
      name: "浏览评价",
      imgs: data.browseCommentsImgs?.split(",") ?? [],
    });
  }

  // 聊天
  if (data.needChat > 0) {
    list.push({
      name: "聊天",
      imgs: data.chatImgs?.split(",") ?? [],
    });
  }

  // 收藏
  if (data.needCollect > 0) {
    list.push({
      name: "收藏",
      imgs: data.collectImgs?.split(",") ?? [],
    });
  }

  // 加购
  if (data.needAddCart > 0) {
    list.push({
      name: "加购",
      imgs: data.addCartImgs?.split(",") ?? [],
    });
  }

  // 评价
  if (data.needComment > 0) {
    list.push({
      name: "评价",
      imgs: data.commentImgs?.split(",") ?? [],
    });
  }

  // 追评
  if (data.needAddComment > 0) {
    list.push({
      name: "追评",
      imgs: data.addCommentImgs?.split(",") ?? [],
    });
  }

  // 回答问题
  if (data.needAnswer > 0) {
    list.push({
      name: "回答问题",
      imgs: data.answerImgs?.split(",") ?? [],
    });
  }

  return list;
});

const fullscreen = ref(window.innerWidth < 780);

watch(
  () => props.value,
  async (val) => {
    if (val) {
      if (detail.value == undefined) {
        loading.value = true;
        const { data } = await taskDetail(props.id);
        detail.value = data;
        loading.value = false;
      }
    }
  }
);

return { __sfc: true,taskDetail, props, emit, show, loading, detail, checkList, fullscreen }
}

})